module.exports = __webpack_public_path__ + "img/ppqy.ee73d308.png";